<div class="experience-scope" [attr.data-theme]="theme">
  <div class="home-experience">
    <header class="home-experience__topbar">
      <div
        class="logo-mark"
        (click)="goHome()"
        title="Cimalti"
        style="cursor: pointer"
      >
        <img
          src="../../../../../assets/images/logo-min-white.svg"
          alt="Cimalti"
        />
      </div>
      <div class="home-experience__brand">
        <div class="home-experience__brand-name">Research library</div>
        <div class="home-experience__brand-sub">Home · Reports · 2026</div>
      </div>
      <div class="home-experience__spacer"></div>
      <button
        class="btn btn-ghost btn-sm exit-btn"
        type="button"
        (click)="goHome()"
        title="Back to home"
      >
        <svg
          viewBox="0 0 24 24"
          width="14"
          height="14"
          fill="none"
          stroke="currentColor"
          stroke-width="1.8"
        >
          <path d="M15 18l-6-6 6-6" />
        </svg>
        <span>Home</span>
      </button>
      <button
        class="icon-btn"
        type="button"
        (click)="toggleTheme()"
        [title]="theme === 'dark' ? 'Switch to light' : 'Switch to dark'"
      >
        @if (theme === "dark") {
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.8"
            width="17"
            height="17"
          >
            <path d="M21 13a9 9 0 11-10-10 7 7 0 0010 10z" />
          </svg>
        }
        @if (theme === "light") {
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.8"
            width="17"
            height="17"
          >
            <circle cx="12" cy="12" r="4" />
            <path
              d="M12 2v2M12 20v2M2 12h2M20 12h2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4"
            />
          </svg>
        }
      </button>
    </header>

    <div class="reports-wrap">
      <div class="reports-head">
        <div>
          <h1 class="reports-title">Research library</h1>
          <p class="reports-subtitle">
            Upload research PDFs from Gavekal, Bloomberg, BofA, and more.
            Cimalti extracts investment views and stages them for review before
            applying to My Views.
          </p>
          <div class="reports-stats">
            <div class="reports-stat">
              <div class="v">{{ totalReports }}</div>
              <div class="l">Reports</div>
            </div>
            <div class="reports-stat">
              <div class="v">{{ totalViews }}</div>
              <div class="l">Views extracted</div>
            </div>
            <div class="reports-stat">
              <div class="v">{{ totalApplied }}</div>
              <div class="l">Applied to portfolios</div>
            </div>
            <div class="reports-stat">
              <div class="v">{{ lastUploaded }}</div>
              <div class="l">Last upload</div>
            </div>
          </div>
        </div>
        <div class="reports-head-actions">
          <button class="btn btn-primary" type="button" (click)="openUpload()">
            Upload research PDF
          </button>
        </div>
      </div>

      <div class="reports-layout">
        <aside class="reports-library">
          @for (r of reports; track trackByReport($index, r)) {
            <button
              class="report-card"
              type="button"
              [class.active]="r.id === activeReportId"
              [class.processing]="r.status === 'processing'"
              [class.fresh]="r.fresh"
              (click)="selectReport(r.id)"
            >
              <div class="report-head">
                <span class="report-source" [ngClass]="r.source">{{
                  sourceShortLabel(r)
                }}</span>
                <span class="report-date">{{ formatDate(r.date) }}</span>
              </div>
              <h3 class="report-title">{{ r.title }}</h3>
              <div class="report-meta">
                <span>{{ r.pageCount ? r.pageCount + " pp." : "…" }}</span>
                <span class="dot"></span>
                @if (r.status === "processing") {
                  <span class="report-status processing">
                    <span class="spin"></span>Extracting views…
                  </span>
                }
                @if (r.status !== "processing") {
                  <span
                    class="report-status"
                    [class.applied]="r.appliedCount > 0"
                  >
                    {{ r.viewsCount }} views · {{ r.appliedCount }} applied
                  </span>
                }
              </div>
            </button>
          }
        </aside>

        <section class="reports-detail">
          @if (activeReport; as r) {
            <div class="rdetail-head">
              <div class="rdetail-crumb">{{ r.sourceLabel }}</div>
              <h2 class="rdetail-title">{{ r.title }}</h2>
              @if (r.status === "processing") {
                <div class="rdetail-meta">
                  <span class="chip"
                    ><span class="spin"></span> Processing</span
                  >
                  <span
                    >Just uploaded · extracting views, holdings, and
                    performance</span
                  >
                </div>
              } @else {
                <div class="rdetail-meta">
                  <span class="chip">{{ r.author }}</span>
                  <span class="chip">{{ formatDate(r.date) }}</span>
                  <span class="chip">{{ r.pageCount }} pp.</span>
                </div>
                <p class="rdetail-summary">{{ r.summary }}</p>
                <div class="rdetail-actions">
                  <button class="btn btn-ghost" type="button">
                    View source PDF
                  </button>
                  <button class="btn btn-ghost" type="button">
                    Re-run extraction
                  </button>
                  <span class="count"
                    ><span>{{ acceptedCount }}</span> of
                    {{ r.extractedViews.length }} selected</span
                  >
                  <button
                    class="btn btn-primary"
                    type="button"
                    (click)="applySelected()"
                  >
                    Apply selected views
                  </button>
                </div>
              }
            </div>
            @if (r.status === "processing") {
              <div class="staging-wrap">
                <div class="staging-banner">
                  <span class="alti-chip">Alti</span>
                  <span
                    >Reading document, extracting investment views. This usually
                    takes 8–15 seconds.</span
                  >
                </div>
                <div class="staging-processing">
                  <div class="spinner"></div>
                  <div>Analysing {{ r.title }}…</div>
                </div>
              </div>
            } @else {
              <div class="staging-wrap">
                <div class="staging-banner">
                  <span class="alti-chip">Alti</span>
                  <span
                    >Extracted <b>{{ activeViewCount }} views</b> across
                    <b>{{ activeThemeCount }} themes</b>. Review each row —
                    accept to stage for My Views, reject to discard.</span
                  >
                </div>
                <div class="staging-toolbar">
                  <button class="mini" type="button" (click)="acceptAll()">
                    Accept all
                  </button>
                  <button class="mini" type="button" (click)="rejectAll()">
                    Reject all
                  </button>
                  <button class="mini" type="button" (click)="acceptHighConf()">
                    Accept high-confidence (≥70%)
                  </button>
                  <div class="grow"></div>
                  <button class="mini" type="button" (click)="acceptMatched()">
                    Only matched assets
                  </button>
                </div>
                <div class="staging-head">
                  <div>Asset</div>
                  <div>View type</div>
                  <div>Value</div>
                  <div>Confidence</div>
                  <div></div>
                </div>
                <div class="staging-rows">
                  @for (v of r.extractedViews; track trackByView($index, v)) {
                    <div class="staging-row" [ngClass]="rowClass(v)">
                      <div class="staging-row-top">
                        <div class="asset-cell">
                          <div class="asset-line">
                            <span class="asset-sym">{{ v.asset }}</span>
                            <span class="match-badge" [ngClass]="v.matched">{{
                              matchedLabel(v)
                            }}</span>
                          </div>
                          <div class="asset-name">{{ v.assetName }}</div>
                        </div>
                        <div>
                          <span
                            class="view-type-pill"
                            [ngClass]="viewTypeClass(v)"
                            >{{ v.viewType }}</span
                          >
                        </div>
                        <div>
                          <span class="view-val" [ngClass]="dirTone(v)">
                            <span class="arrow">{{ dirArrow(v) }}</span
                            >{{ valSign(v) }}{{ v.value }}%
                          </span>
                        </div>
                        <div>
                          <div class="conf-cell">
                            <div class="lbl">
                              <span>{{ v.confidence }}%</span>
                              <span class="q">{{ v.confidenceQual }}</span>
                            </div>
                            <div class="conf-bar">
                              <div
                                class="fill"
                                [style.width.%]="v.confidence"
                              ></div>
                            </div>
                          </div>
                        </div>
                        <div class="toggle-cell">
                          <div class="accept-toggle">
                            <button
                              type="button"
                              class="accept"
                              [class.on]="v.accepted"
                              (click)="accept(v)"
                            >
                              Accept
                            </button>
                            <button
                              type="button"
                              class="reject"
                              [class.on]="v.rejected"
                              (click)="reject(v)"
                            >
                              Reject
                            </button>
                          </div>
                        </div>
                      </div>
                      <button
                        type="button"
                        class="excerpt-card"
                        [ngClass]="'source-' + r.source"
                        [attr.aria-label]="'Open PDF at page ' + v.page"
                        (click)="openPdfPreview(v)"
                      >
                        <div class="excerpt-source">
                          <span class="source-pill">
                            <svg
                              width="11"
                              height="11"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linejoin="round"
                              aria-hidden="true"
                            >
                              <path d="M7 3h9l4 4v14H7z" />
                              <path d="M15 3v4h4" />
                            </svg>
                            {{ sourceMeta(r).short }}
                          </span>
                          <span class="source-title">{{
                            sourceMeta(r).titleShort
                          }}</span>
                          <span class="source-page">p. {{ v.page }}</span>
                        </div>
                        <blockquote class="excerpt-quote">
                          {{ v.excerpt }}
                        </blockquote>
                        <div class="excerpt-link">
                          <span>Open PDF at p. {{ v.page }}</span>
                          <svg
                            width="12"
                            height="12"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            aria-hidden="true"
                          >
                            <path d="M7 17L17 7" />
                            <path d="M8 7h9v9" />
                          </svg>
                        </div>
                      </button>
                    </div>
                  }
                </div>
              </div>
              <div class="preview-views-wrap">
                <div class="preview-views-head">
                  <div>
                    <h4 class="preview-views-title">
                      Preview · My Views after apply
                    </h4>
                    <p class="preview-views-sub">
                      These rows will be appended to your portfolio views with
                      an <b>Imported</b> badge and a back-link to the source
                      report.
                    </p>
                  </div>
                </div>
                <table class="pv-table">
                  <thead>
                    <tr>
                      <th>Source</th>
                      <th>Asset</th>
                      <th>Type</th>
                      <th>Value</th>
                      <th>Confidence</th>
                    </tr>
                  </thead>
                  <tbody>
                    @if (!acceptedViews.length) {
                      <tr>
                        <td
                          colspan="5"
                          style="
                            padding: 22px;
                            text-align: center;
                            color: var(--text-faint);
                          "
                        >
                          No views selected yet — use <b>Accept</b> above to
                          stage views.
                        </td>
                      </tr>
                    }
                    @for (v of acceptedViews; track trackByView($index, v)) {
                      <tr>
                        <td>
                          <span class="imported-badge"
                            >Imported · {{ r.source.toUpperCase() }}</span
                          >
                        </td>
                        <td>
                          <b>{{ v.asset }}</b>
                          <span style="color: var(--text-dim); font-size: 12px">
                            {{ v.assetName }}</span
                          >
                        </td>
                        <td>{{ v.viewType }}</td>
                        <td
                          class="view-val"
                          [ngClass]="dirTone(v)"
                          style="font-family: var(--font-mono)"
                        >
                          {{ valSign(v) }}{{ v.value }}%
                        </td>
                        <td>{{ v.confidence }}%</td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            }
          } @else {
            <div class="empty-detail">
              <h3>No report selected</h3>
              <p>Upload a research PDF to get started.</p>
              <button
                class="btn btn-primary"
                type="button"
                (click)="openUpload()"
              >
                Upload research PDF
              </button>
            </div>
          }
        </section>
      </div>
    </div>

    @if (toasts.length) {
      <div class="toast-wrap">
        @for (t of toasts; track t) {
          <div class="toast"><span class="dot"></span>{{ t.text }}</div>
        }
      </div>
    }

    <app-exp-pdf-drop
      [open]="pdfDropOpen"
      (close)="closeUpload()"
      (uploaded)="onUploaded($event)"
    ></app-exp-pdf-drop>

    <app-exp-pdf-preview-drawer
      [open]="pdfPreviewOpen"
      [context]="pdfPreviewContext"
      (close)="closePdfPreview()"
      (download)="downloadFromPreview()"
    ></app-exp-pdf-preview-drawer>
  </div>
</div>
